import React, {Component} from 'react';
// import createClass from 'create-react-class';
import Select from 'react-select';
import './FilterColumns.css';
import * as _ from 'lodash';

class FilterColumns extends Component {
	constructor(props, context) {
		super(props, context);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.updateState = this.updateState.bind(this);
		this.applyColumnFilter = this.applyColumnFilter.bind(this);
		this.confirmChange = this.confirmChange.bind(this);

		this.state = { removeSelected: true, stayOpen: true, value: [] }
	  }

	confirmChange() {
		return window.confirm("Modifying visible columns will clear filters. Still wish to proceed?");
	}
	
	handleSelectChange (value) {
		if(!_.isEmpty(this.props.rowFilter)) {
			var clearFilter = this.confirmChange();
			if(clearFilter) {
				this.updateState(value);
				this.props.setFilters({});
			}
		}
		else 
		{
			this.updateState(value);
		}

	}
	updateState(value) {
		if(value.length < this.state.value.length) {
			this.props.setColumns(value);
		}
		this.setState({ value });
	}
	applyColumnFilter() {
		if(this.state.value.length > 0) {
			this.props.setColumns(this.state.value);
		}
	}

	render () {
		const { disabled, stayOpen, value  } = this.state;
		const options = this.props.columnFilter;
		return (
			<div className="multiselect" id="columns-multiselect">
				<Select
					closeOnSelect={!stayOpen}
					disabled={disabled}
					multi
					onChange={this.handleSelectChange}
					onBlur={this.applyColumnFilter}
					options={options}
					placeholder="Select columns to hide"
					removeSelected={this.state.removeSelected}
					simpleValue
					value={value}
				/>
			</div>
		);
	}
}

export default FilterColumns;


// WEBPACK FOOTER //
// ./src/components/FilterColumns/FilterColumns.js